// src/components/Auth/PasswordStrengthIndicator.js
import React from 'react';
import styles from './PasswordStrengthIndicator.module.css'; // We'll create this CSS file next
import { passwordRequirementDescriptions } from '../../utils/validation'; // Import descriptions

const PasswordStrengthIndicator = ({ validationState }) => {
  // If no validation state is provided (e.g., before typing), don't render
  if (!validationState) {
    return null;
  }

  return (
    <div className={styles.passwordStrengthIndicator}>
      <ul className={styles.requirementList}>
        {Object.entries(passwordRequirementDescriptions).map(([key, description]) => (
          <li
            key={key}
            className={`${styles.requirementItem} ${
              validationState[key] ? styles.met : styles.unmet
            }`}
          >
            {validationState[key] ? '✓' : '✗'} {description}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrengthIndicator;